import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { RoarAssignmentFormService } from '../../../../shared/services/roarAssignmentForm.service';

@Component({
  selector: 'review-roar-activity',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-roar-activity.component.html',
  styleUrl: './review-roar-activity.component.css'
})
export class ReviewRoarActivityComponent implements OnInit {
  
  @Input() roarId: string | null = null;
  
  yesNo = EYesNo;
  roarAssignmentForm: any | null = null;
  loading: boolean = false;
  
  sections = [
    {
      sectionName: "ROAR Activity Details",
      children: [
        {
          type: 'string',
          questionText: "ROAR Activity Date:",
          answer: "roar_activity_date"
        },
        {
          type: 'string',
          questionText: "ROAR Activity Time:",
          answer: "roar_activity_time"
        },
        {
          type: 'string',
          questionText: "Activity Duration:",
          answer: "activity_duration"
        },
        {
          type: 'string',
          questionText: "Please provide all relevant details for this activity including, if applicable, indicators and an estimation of whether this was a successful intervention:",
          answer: "details"
        }
      ]
    },
    {
      sectionName: "Official Signature(s)",
      children: [
        {
          type: 'string',
          questionText: "Signature:",
          answer: "activity_user_signature_name"
        },
        {
          type: 'string',
          questionText: "Name:",
          answer: "activity_user_fullname"
        },
        {
          type: 'string',
          questionText: "Email address:",
          answer: "activity_user_email"
        },
        {
          type: 'string',
          questionText: "Title:",
          answer: "activity_user_title"
        },
        {
          type: 'string',
          questionText: "Workphone:",
          answer: "activity_user_workphone"
        },
        {
          type: 'datetime',
          questionText: "Date & Time:",
          answer: "activity_date_time_signed"
        }
      ]
    },
  ];

  constructor(
    private roarAssignedFormService: RoarAssignmentFormService
  ) { }

  ngOnInit(): void {
    this.loadRoarAssignmentForm();
  }

  loadRoarAssignmentForm(): void {
    if (this.roarId) {
      this.loading = true;
      this.roarAssignedFormService.getRoarAssignmentFormByRoarId(this.roarId).subscribe({
        next: (response) => {
          if (Object.keys(response).length === 0) {
            this.roarAssignmentForm = null;
            this.loading = false;
            return
          } else {
            this.roarAssignmentForm = response;
            this.loading = false;
            return
          }
        },
        error: (error) => {
          console.error('Error:', error);
        }
      });
    }
  }


  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }

}
